module.exports = __webpack_public_path__ + "img/company_icon.1c0c0e37.png";